import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            吃瓜群众热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            来自真实读者的声音。每一条评论都是吃瓜群众的真情实感，看看大家对最新黑料爆料的看法。
          </p>
        </div>

        <div className="space-y-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img
                    src={comment.avatar}
                    alt={comment.nickname}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-semibold text-sm text-foreground-900">
                      {comment.nickname}
                    </span>
                    {comment.tag && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-accent-100 text-accent-700 whitespace-nowrap">
                        {comment.tag}
                      </span>
                    )}
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-thumb-up-line"></i>
                      {comment.likes}
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-share-forward-line"></i>
                      分享
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}